import { env } from '../runtimeEnv';

type ConfigurationType = {
  backendEndpoint?: string;
  corsRequests?: boolean;
};

let Configuration: ConfigurationType;

if (process.env.NODE_ENV === 'test') {
  Configuration = {};
} else if (process.env.NODE_ENV === 'development') {
  Configuration = {
    backendEndpoint: env('BACKEND_ENDPOINT'),
    corsRequests: false,
  };
} else {
  Configuration = {
    backendEndpoint: env('BACKEND_ENDPOINT'),
    corsRequests: true,
  };
}

export default Configuration;
